import { InfoIcon } from '~/@mid_ui/icons/InfoIcon'
import { InfoCardWrapper } from '~/@mid_ui/info-card-wrapper/InfoCardWrapper'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { AssessExperienceStep } from './analysis-form-unsophisticated/AssessExperienceStep'
import { BackButton } from '~/@pages_investing/project-detail/project-detail_ui/back-button/BackButton'
import { useQuestionsV1 } from './questions'

type Props = { showNeedMoreInfo?: boolean; onGoBack(): void }

function NeedMoreInfoCard() {
  return (
    <InfoCardWrapper>
      <div className="flex flex-row gap-2">
        <InfoIcon className="mt-1" />
        <div className="flex flex-col gap-1">
          <p>Vyzerá to, že potrebujeme viac informácií.</p>
          <p className="text-sm leading-[21px] font-medium">
            Vzhľadom k tomu, že splňujete iba niektoré parametre, prejdite do
            investorského dotazníku a odpovedzte na niekoľko otázok.
          </p>
        </div>
      </div>
    </InfoCardWrapper>
  )
}

export function AssessExperienceStage({ showNeedMoreInfo, onGoBack }: Props) {
  const { unsophisticated: unsophisticatedQuestions } = useQuestionsV1()

  return (
    <div className="flex flex-col gap-10 items-start">
      <div className="flex justify-between items-center">
        <BackButton onClick={onGoBack}>Späť</BackButton>
      </div>
      {showNeedMoreInfo && <NeedMoreInfoCard />}
      <StepTitle>
        {unsophisticatedQuestions.investmentExperience.question.label}
      </StepTitle>
      <AssessExperienceStep />
    </div>
  )
}
